import { pollInterval } from '../realtime/live-updates';
import { useQuery } from '@tanstack/react-query';
import type { DashboardSummary } from '@neuroedge/shared';
import { apiClient, ApiClientError } from './client';

const KEY = ['reports', 'dashboard'] as const;
/** The dashboard is a live overview - keep it reasonably fresh while open. */
const POLL_MS = 30_000;

export const getDashboardSummary = () => apiClient.get<DashboardSummary>('/reports/dashboard');

export function useDashboardSummary() {
  return useQuery<DashboardSummary, ApiClientError>({
    queryKey: KEY,
    queryFn: getDashboardSummary,
    refetchInterval: pollInterval(POLL_MS),
  });
}
